var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "database",
    d: "M22,2.87A2.812,2.812,0,0,0,19.25,0H2.75A2.812,2.812,0,0,0,0,2.87v2.87A2.921,2.921,0,0,0,.715,7.652,2.921,2.921,0,0,0,0,9.565v2.87a2.921,2.921,0,0,0,.715,1.913A2.921,2.921,0,0,0,0,16.261V22H22V16.261a2.921,2.921,0,0,0-.715-1.913A2.921,2.921,0,0,0,22,12.435V9.565a2.921,2.921,0,0,0-.715-1.913A2.921,2.921,0,0,0,22,5.739Zm-20.167,0a.937.937,0,0,1,.917-.957H4.583V3.826H6.417V1.913H8.25V3.826h1.833V1.913H19.25a.937.937,0,0,1,.917.957v2.87a.937.937,0,0,1-.917.957H2.75a.937.937,0,0,1-.917-.957Zm18.333,6.7v2.87a.937.937,0,0,1-.917.957H2.75a.937.937,0,0,1-.917-.957V9.565a.937.937,0,0,1,.917-.957H4.583v1.913H6.417V8.609H8.25v1.913h1.833V8.609H19.25A.937.937,0,0,1,20.167,9.565Zm0,10.522H1.833V16.261A.937.937,0,0,1,2.75,15.3H4.583v1.913H6.417V15.3H8.25v1.913h1.833V15.3H19.25a.937.937,0,0,1,.917.957Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.3c21d7bfd7ac769f044c207a003aa928.svg";
export { ForwardRef as ReactComponent };